import React from 'react';
import { Outlet } from 'react-router-dom';
import { useLoaderData } from 'react-router';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import NotificationProvider from '../../contexts/ContextNotification';
import UserProvider from '../../contexts/ContextUser';
import Notifications from '../../Notifications';

/** Full-viewport Console shell: dark sidebar + sticky topbar + routed page. */
export default function ConsoleLayout() {
  const { user } = useLoaderData();
  return (
    <div className="cc-console" style={{ display: 'flex', background: 'var(--neutral-50)', minHeight: '100vh', fontFamily: 'var(--font-sans)' }}>
      <NotificationProvider>
        <UserProvider defaultUser={user}>
          <Notifications notifications={[]} />
          <Sidebar />
          <main style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <Topbar />
            <Outlet />
          </main>
        </UserProvider>
      </NotificationProvider>
    </div>
  );
}
